import { createContext, useContext } from 'react';

import type { IUseCodeProps } from '../components/election-result/upload-result/hooks';
import { defaultSummary, type ursType } from '../components/election-result/upload-result/utils';
import type { IUSH } from '../hooks/state';
import type { IComponentState, INestedMetaData } from '../layout/component-state';

export type themeType = 'dark' | 'light';

export interface IGlobalContext {
	global: IUSH<IComponentState>;
	onStage: (stage: ursType) => void;
	getCodeProps: IUseCodeProps;
}

const nestedMetaData: INestedMetaData = {
	electoralDivision: {
		type: null,
		ids: [],
	},
	parent: {
		id: 0,
		name: '',
		type: null,
	},
	states: [],
	lgas: [],
	wards: [],
	pollingunits: [],
};

export const defaultParentCode = {
	code: '',
	name: '',
	codeId: 0,
	status: false,
};

export const defaultChildCode = {
	code: '',
	name: '',
	codeId: 0,
	parent: 0,
	status: false,
};

export const defaultReportIssues = {
	userId: '',
	report: {
		title: '',
		body: '',
	},
	phoneNumber: '',
	email: '',
};

export const defaultSelectedElection = {
	constituency: '',
	constituencyId: 0,
	date: '',
	electionCycleId: 0,
	electiveCategory: '',
	id: 0,
	irevReference: '',
	isActive: false,
	name: '',
	state: '',
	stateId: 0,
};

export const initComponentState: IComponentState = {
	draftStatus: false,
	stage: 'Select Election',
	isGenerateResult: false,
	isPreview: false,
	partyVotes: [],
	resultSummary: defaultSummary,
	files: [],
	uploadedFiles: [],
	isUpdate: false,
	selectedParentCode: defaultParentCode,
	partyVoteStage: 'Party Votes',
	selectedChildCode: defaultChildCode,
	parentCodes: [],
	childCodes: [],
	reportIssues: defaultReportIssues,
	electionCycle: 0,
	electionCycleName: '',
	resultType: '',
	electionName: '',
	electionId: 0,
	user: {
		userId: 0,
		name: '',
		email: '',
	},
	selectedED: null,
	selectedResults: [],
	electoralDivisionCode: [],
	states: [],
	electionData: [],
	selectedElection: defaultSelectedElection,
	electiveCategory: null,
	selectedFile: {} as File,
	selectedUploadedFile: '',
	filterParams: [],
	filter: {
		key: '',
		value: '',
	},
	suggestionType: '',
	filterTitles: [],
	filterPrompt: '',
	openFilterParam: false,
	hideSuggestionItems: false,
	filterCollapse: false,
	rightPanelLoad: false,
	filterData: [],
	onExtract: false,
	nestedMetaData,
	nestedMetaDataHistory: [],
};

const initGlobalContext = {
	global: {
		state: initComponentState,
		updateState: () => {},
		clearState: () => {},
		clearAll: () => {},
	},
	onStage: () => {},
	getCodeProps: {
		childCodes: [],
		clearCodes: () => {},
		handleCodes: () => {},
		load: false,
	},
};

export const GlobalContext = createContext<IGlobalContext>(initGlobalContext);

export const useGlobalContext = (): IGlobalContext => {
	const globalContext = useContext(GlobalContext);
	if (!globalContext) {
		throw new Error('useGlobalContext must be used within a GlobalProvider');
	}
	return {
		...globalContext,
	};
};
